import React, { useState } from 'react'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import { preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import { BiPlusMedical } from 'react-icons/bi'
import { TiDelete } from 'react-icons/ti'
import ErrorMessage from 'components/ErrorMessage'
import helpers from 'utils/helpers'

const SubscriptionAdd = ({ allSubscription, handleCategory }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    watch,
    resetField,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })
  const [addMerchantLoading, setAddMerchantLoading] = useState(false)
  const [splFeature, setSplFeature] = useState([])
  const [descriptionError, setDescriptionError] = useState(false)

  const checkFields = feature => {
    let isValid = true
    if (feature.length === 0) {
      setDescriptionError(true)
      isValid = false
    } else {
      setDescriptionError(false)
    }
    if (watch('description')?.length < 3 && feature.length === 0) {
      isValid = false
    }
    return isValid
  }

  const preventMax = e => {
    if (e.target.value.length > 10) {
      e.target.value = e.target.value.slice(0, 10)
    }
  }
  const preventMaxHundredDays = e => {
    if (e.target.value > 100) {
      e.target.value = e.target.value.slice(0, 1000)
    }
  }

  const specialFeatureData = watch('description')

  const AddInputValue = () => {
    if (specialFeatureData !== undefined && specialFeatureData.length >= 3) {
      setSplFeature([...splFeature, specialFeatureData])
      resetField('description')
    }
  }
  const handleDeleteData = id => {
    const updatedDataArray = splFeature.filter((data, i) => i !== id)
    setSplFeature(updatedDataArray)
  }

  const numericInputPattern = event => {
    if (
      !['Backspace', 'Delete', 'Tab'].includes(event.key) &&
      !/[0-9]/.test(event.key)
    ) {
      event.preventDefault()
    }
  }

  const onSubmit = async data => {
    let feature = [...splFeature]
    if (watch('description')?.length >= 3) feature.push(watch('description'))
    const isValid = checkFields(feature)
    if (!isValid) return
    setAddMerchantLoading(true)
    try {
      const payload = {
        name: data.name?.trim(),
        amount: data?.amount,
        duration: data?.duration,
        description: feature,
        noOfEmployee: data?.noOfEmployee,
        noOfHR: data?.noOfHR,
        noOfAccountant: data?.noOfAccountant
      }
      const res = await apiPost(apiPath.subscriptionAdd, payload)
      if (res?.data?.success) {
        allSubscription()
        handleCategory(false)
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setAddMerchantLoading(false)
    }
  }

  const renderFooter = () => (
    <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
      <button
        className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
        type='button'
        onClick={() => handleCategory(false)}
      >
        {t('O_BACK')}
      </button>
      {addMerchantLoading ? (
        <button className='font-normal text-sm px-8 py-2.5 bg-LightBlue text-white active:bg-emerald-600 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
          <div className='spinner-container'>
            <div className='loading-spinner'></div>
          </div>
        </button>
      ) : (
        <button
          onClick={handleSubmit(onSubmit, () => {
            const isValid = checkFields(splFeature)
            if (!isValid) return
          })}
          className='font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear bg-LightBlue text-white active:bg-emerald-600transition-all duration-150'
          type='submit'
        >
          {t('O_ADD')}
        </button>
      )}
    </div>
  )

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='px-7 md:py-4 sm:px-2 sm:py-8'>
            <div className='border-0 rounded-lg flex-col w-full bg-white outline-none shadow-lg relative flex focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='font-semibold text-xl '>
                  {t('ADD_SUBSCRIPTION')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleCategory(false)}
                  title='Close'
                >
                  <span title='Close' className=' text-4xl text-[#B8BBBF] '>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        type='text'
                        autoFocus
                        maxLength={50}
                        onInput={e => preventMaxInput(e, 50)}
                        wrapperClassName='relative z-0 w-full group'
                        name='name'
                        inputLabel={
                          <>
                            {t('SUBSCRIPTION_NAME')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        register={register(
                          'name',
                          formValidation['subscriptionName']
                        )}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('AMOUNT')} ($)
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        onInput={e => preventMax(e)}
                        maxLength={10}
                        onKeyDown={numericInputPattern}
                        type='text'
                        name='amount'
                        id='amount'
                        register={register('amount', {
                          required: {
                            value: true,
                            message: 'Please enter amount.'
                          },
                          min: {
                            value: 1,
                            message: 'Minimum value must is 1.'
                          },
                          maxLength: {
                            value: 10,
                            message: 'Maximum limit is 10 characters.'
                          },
                          pattern: {
                            value: true,
                            message: 'Only digits are allowed.'
                          }
                        })}
                      />
                    </div>
                  </div>
                  <div className='sm:px-2 md:py-4 sm:py-8 px-7'>
                    <div className='z-0 w-full relative group'>
                      <OInputField
                        wrapperClassName='w-full relative z-0 group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('DURATION')} (In days)
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        name='duration'
                        id='duration'
                        onInput={e => preventMaxHundredDays(e)}
                        maxLength={4}
                        onKeyDown={numericInputPattern}
                        register={register('duration', {
                          required: {
                            value: true,
                            message: 'Please enter duration.'
                          },
                          pattern: {
                            value: true,
                            message: 'Only digits are allowed.'
                          },
                          min: {
                            value: 15,
                            message: 'Minimum value must is 15.'
                          },
                          max: {
                            value: 1095,
                            message: 'Maximum limit is 1095 days.'
                          }
                        })}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        inputLabel={
                          <>
                            {t('NUMBER_OF_EMPLOYEE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        name='noOfEmployee'
                        id='noOfEmployee'
                        onInput={e => preventMax(e)}
                        maxLength={10}
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        onKeyDown={numericInputPattern}
                        register={register('noOfEmployee', {
                          required: {
                            value: true,
                            message: 'Please enter number of employees.'
                          },
                          maxLength: {
                            value: 10,
                            message: 'Maximum limit is 10 characters.'
                          },
                          min: {
                            value: 1,
                            message: 'Minimum value must is 1.'
                          },
                          pattern: {
                            value: true,
                            message: 'Only digits are allowed.'
                          }
                        })}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        type='text'
                        name='noOfHR'
                        id='noOfHR'
                        onInput={e => preventMax(e)}
                        maxLength={10}
                        onKeyDown={numericInputPattern}
                        inputLabel={
                          <>
                            {t('NUMBER_OF_HR')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        register={register('noOfHR', {
                          required: {
                            value: true,
                            message: 'Please enter number of HR.'
                          },
                          maxLength: {
                            value: 10,
                            message: 'Maximum limit is 10 characters.'
                          },
                          pattern: {
                            value: true,
                            message: 'Only digits are allowed.'
                          },
                          min: {
                            value: 1,
                            message: 'Minimum value must is 1.'
                          }
                        })}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='group relative z-0 w-full '>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('NUMBER_OF_ACCOUNTANT')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        maxLength={10}
                        onKeyDown={numericInputPattern}
                        type='text'
                        name='noOfAccountant'
                        id='noOfAccountant'
                        onInput={e => preventMax(e)}
                        register={register('noOfAccountant', {
                          required: {
                            value: true,
                            message: 'Please enter number of accountant.'
                          },
                          maxLength: {
                            value: 10,
                            message: 'Maximum limit is 10 characters.'
                          },
                          pattern: {
                            value: true,
                            message: 'Only digits are allowed.'
                          },
                          min: {
                            value: 1,
                            message: 'Minimum value must is 1.'
                          }
                        })}
                      />
                    </div>
                  </div>
                </div>
                <div className='grid'>
                  <div className='sm:py-8 px-7 md:py-4 sm:px-2 '>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        onInput={e => preventMaxInput(e, 300)}
                        inputLabel={
                          <>
                            {t('DESCRIPTION')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        greyClass
                        type='text'
                        name='description'
                        register={register('description')}
                        wrapperClassName='relative z-0 w-full group'
                        maxLength={300}
                      />
                      {watch('description') == '' && descriptionError && (
                        <ErrorMessage message='Please enter description.' />
                      )}
                      {watch('description') != '' && (
                        <ErrorMessage
                          message={helpers?.ternaryCondition(
                            watch('description')?.length < 3,
                            'Minimum length must be 3',
                            ''
                          )}
                        />
                      )}
                      <span className='right-[20px] absolute password_view top-[18px] '>
                        <BiPlusMedical onClick={AddInputValue} />
                      </span>
                      <div className='max-h-[200px] overflow-auto '>
                        {splFeature &&
                          splFeature.map((item, i) => {
                            return (
                              <ul key={i}>
                                <li className='text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5  flex justify-between bg-gray-100 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500 mt-2'>
                                  {item}{' '}
                                  <span className='w-[32px]'>
                                    {' '}
                                    <TiDelete
                                      onClick={() => handleDeleteData(i)}
                                      className='h-5 w-10 '
                                    />
                                  </span>
                                </li>
                              </ul>
                            )
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {renderFooter()}
            </div>
          </div>
        </div>
      </div>
      <div className='inset-0 z-40 opacity-25 fixed bg-black' />
    </>
  )
}

export default SubscriptionAdd
